(function () {
  'use strict';
  if (window.__atrandomLineTracking) return;
  window.__atrandomLineTracking = true;
  var shop = window.Shopify || {};
  if (shop.designMode || (shop.theme && shop.theme.role !== 'main')) return;
  var measurementId = 'G-RBZTQPP2TR';
  var layerName = 'atrandomLineDataLayer';
  var initialized = false;
  var pageLocation = window.location.origin + window.location.pathname;
  var referrer = '';
  try { referrer = document.referrer ? new URL(document.referrer).origin : ''; } catch (error) {}
  function command() {
    window[layerName].push(arguments);
  }
  function allowed() {
    try {
      return !!(window.Shopify && window.Shopify.customerPrivacy &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed());
    } catch (error) { return false; }
  }
  function syncConsent() {
    var canMeasure = allowed();
    if (!initialized && canMeasure) {
      initialized = true;
      window[layerName] = window[layerName] || [];
      command('consent', 'default', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied'
      });
      command('consent', 'update', { analytics_storage: 'granted' });
      command('js', new Date());
      command('config', measurementId, {
        send_page_view: false,
        allow_google_signals: false,
        allow_ad_personalization_signals: false,
        page_location: pageLocation,
        page_referrer: referrer
      });
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' +
        measurementId + '&l=' + layerName;
      script.id = 'atrandom-line-google-tag';
      document.head.appendChild(script);
    } else if (initialized) {
      command('consent', 'update', {
        analytics_storage: canMeasure ? 'granted' : 'denied'
      });
    }
  }
  function position(anchor) {
    if (anchor.closest('header, .site-header, #shopify-section-header')) return 'header';
    if (anchor.closest('footer, .site-footer, #shopify-section-footer')) return 'footer';
    if (window.location.pathname === '/' && anchor.closest('.feature-row')) return 'home_repair';
    return 'content';
  }
  document.addEventListener('click', function (event) {
    if (event.button !== undefined && event.button !== 0) return;
    var target = event.target;
    var anchor = target && typeof target.closest === 'function' ? target.closest('a[href]') : null;
    if (!anchor) return;
    var url;
    try { url = new URL(anchor.getAttribute('href'), window.location.href); } catch (error) { return; }
    if (!['https:', 'http:'].includes(url.protocol)) return;
    if (!['lin.ee', 'line.me', 'www.line.me', 'line.naver.jp', 'www.line.naver.jp'].includes(url.hostname.toLowerCase())) return;
    if (!allowed()) return;
    if (!initialized) syncConsent();
    if (!initialized) return;
    var place = position(anchor);
    command('event', 'line_click', {
      send_to: measurementId,
      page_location: pageLocation,
      page_path: window.location.pathname,
      page_referrer: referrer,
      link_domain: url.hostname.toLowerCase(),
      link_url: url.origin,
      link_id: 'line_' + place,
      link_text: 'LINE問い合わせ',
      button_location: place
    });
  }, true);
  document.addEventListener('visitorConsentCollected', syncConsent);
  if (shop.customerPrivacy) {
    syncConsent();
  } else if (typeof shop.loadFeatures === 'function') {
    shop.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) syncConsent();
    });
  }
})();